export interface ISuggestion<T> {
  subject: T;
  displayText: string;
  searchText: string;
  highlighted: boolean;
}

export enum Key {
  TAB = 9,
  ENTER = 13,
  ESCAPE = 27,
  END = 35,
  HOME = 36,
  ARROW_UP = 38,
  ARROW_DOWN = 40
}
